/**
 * Shown instead of the panel when the viewer has no usable GitLab
 * credential for the project's server (or GitLab rejected the stored one).
 * Sanctum reads the project only as the viewer, so there is nothing to
 * show until they connect one. It names no project: GitLab hasn't vouched
 * that this viewer may see it.
 */

import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '@utils/constants';

export function ConnectGitPrompt(): ReactElement {
  return (
    <div className="connect-git-prompt" role="note">
      <p>
        Connect a GitLab credential to see this project&apos;s Agent runs. Sanctum reads the
        project as you, so it shows only what GitLab lets you see.
      </p>
      <Link to={ROUTES.SETTINGS} className="runs-page__link">
        Settings → Git credentials
      </Link>
    </div>
  );
}
